<template>
  <div>
    <page-title value="Extended Pattern Settings"></page-title>

    <div class="my-8">
      <h5>Monthly & Spot</h5>
      <v-select
        v-model="billingPeriod"
        :items="billingPeriodItems"
        item-title="text"
        item-vlaue="value"
        variant="outlined"
        hide-details
        density="compact"
      ></v-select>
    </div>

    <div>
      <div v-if="billingPeriod == 'monthly'">
        <monthly-pattern-container></monthly-pattern-container>
      </div>
      <div v-if="billingPeriod == 'spot'" class="my-8">
        <h5>Extended Time Frame</h5>
        <v-select
          v-model="category"
          :items="categoryItems"
          item-title="text"
          item-value="value"
          variant="outlined"
          hide-details
          density="compact"
        ></v-select>
      </div>
    </div>

    <div v-if="billingPeriod == 'spot'">
      <!-- Fixed Time (Nursery) -->
      <div v-if="category == 'spot-nursery'">
        <spot-nursery-pattern-container></spot-nursery-pattern-container>
      </div>

      <!-- Fixed Time (Kindergarten) -->
      <div v-else-if="category == 'spot-kindergarten'">
        <spot-kindergarten-pattern-container></spot-kindergarten-pattern-container>
      </div>

      <!-- Flexible Time -->
      <div v-else-if="category == 'spot-flexible'">
        <spot-flexible-pattern-container></spot-flexible-pattern-container>
      </div>

      <!-- Morning/Evening Combined -->
      <div v-else-if="category == 'spot-combination'">
        <spot-combination-pattern-container></spot-combination-pattern-container>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import MonthlyPatternContainer from "@/containers/nursery-hours/MonthlyPatternContainer.vue";
import SpotNurseryPatternContainer from "@/containers/nursery-hours/SpotNurseryPatternContainer.vue";
import SpotKindergartenPatternContainer from "@/containers/nursery-hours/SpotKindergartenPatternContainer.vue";
import SpotFlexiblePatternContainer from "@/containers/nursery-hours/SpotFlexiblePatternContainer.vue";
import SpotCombinationPatternContainer from "@/containers/nursery-hours/SpotCombinationPatternContainer.vue";

export default defineComponent({
  name: "NurseryHoursEdit",

  components: {
    PageTitle,
    MonthlyPatternContainer,
    SpotNurseryPatternContainer,
    SpotKindergartenPatternContainer,
    SpotFlexiblePatternContainer,
    SpotCombinationPatternContainer,
  },

  mounted() {
    if (this.$route.query && this.$route.query.category) {
      const _category = this.$route.query.category;
      if (_category == "monthly") {
        this.billingPeriod = "monthly";
      } else if (_category == "spotNursery") {
        this.billingPeriod = "spot";
        this.category = "spot-nursery";
      } else if (_category == "spotKindergarten") {
        this.billingPeriod = "spot";
        this.category = "spot-kindergarten";
      } else if (_category == "spotCombination") {
        this.billingPeriod = "spot";
        this.category = "spot-combination";
      } else if (_category == "spotFlexible") {
        this.billingPeriod = "spot";
        this.category = "spot-flexible";
      }
    }
  },

  data() {
    return {
      billingPeriod: "" as "monthly" | "spot" | "",
      billingPeriodItems: [
        { text: "", value: "" },
        { text: "Monthly", value: "monthly" },
        { text: "Spot", value: "spot" },
      ],
      category: "",
      categoryItems: [
        { text: "Fixed Time (Nursery)", value: "spot-nursery" },
        { text: "Fixed Time (Kindergarten)", value: "spot-kindergarten" },
        { text: "Flexible Time", value: "spot-flexible" },
        { text: "Morning/Evening Combined", value: "spot-combination" },
      ],
    };
  },
});
</script>

<style>
.menu-header {
  color: #029ec0;
  font-weight: bold;
  font-size: 14px;
  margin-top: 16px;
  margin-bottom: 4px;
  padding: 4px 8px;
  border-bottom: solid 1px #029ec0;
}
</style>
